import { SubscriptionPlanType } from 'models/user/userWorkspaceDTOs'
import { useMemo } from 'react'
import { useUserData } from 'components/contexts/UserDataContext'
import { workspacePlanType } from 'constants/workspaces/workspaceMemberLimit'

export const useWorkspacePlan = () => {
  const { currentUserWorkspace, hasWorkspaceActiveSubscription } = useUserData()

  return useMemo(
    () => {
      const planType = currentUserWorkspace?.plan
        ? workspacePlanType[currentUserWorkspace.plan]
        : undefined

      return {
        isWorkspacePersonal: planType === SubscriptionPlanType.PERSONAL,
        isWorkspaceEnterprise: planType === SubscriptionPlanType.ENTERPRISE,
        isWorkspacePro: planType === SubscriptionPlanType.PRO,
        /**
         * Whether paid/SaaS features should be unlocked for the user.
         * Re-exposed from `UserDataContext` (the canonical owner): gates on the currently selected
         * workspace being a paid (non-personal) plan with an active subscription status.
         */
        hasWorkspaceActiveSubscription,
      }
    },
    [currentUserWorkspace?.plan, hasWorkspaceActiveSubscription]
  )
}
